export function parseFilterName(options) {
    const { dict, filter, oddsStyle, } = options;
    if (filter.venueRole) {
        return parseParticipantFilterName(options);
    }
    if (filter.minAmericanOdds && filter.maxAmericanOdds) {
        return `${getDisplayOdds(filter.minDisplayOdds, oddsStyle)} ${dict.BetweenFilterName} ${getDisplayOdds(filter.maxDisplayOdds, oddsStyle)}`;
    }
    if (filter.maxAmericanOdds) {
        return `${dict.UnderFilterName} ${getDisplayOdds(filter.maxDisplayOdds, oddsStyle)}`;
    }
    if (filter.minAmericanOdds) {
        return `${dict.OverFilterName} ${getDisplayOdds(filter.minDisplayOdds, oddsStyle)}`;
    }
    return filter.name;
}
function getDisplayOdds(displayOdds, oddsStyle) {
    return displayOdds ? displayOdds[oddsStyle] : "";
}
function parseParticipantFilterName({ dict, filter, events, }) {
    var _a, _b;
    if (filter.venueRole === "Mixed") {
        return dict.MixedFilterName;
    }
    if (filter.eventId) {
        return ((_b = (_a = events
            .get(filter.eventId)) === null || _a === void 0 ? void 0 : _a.participants.find(x => x.venueRole === filter.venueRole)) === null || _b === void 0 ? void 0 : _b.name) || filter.name;
    }
    return filter.name;
}
//# sourceMappingURL=parseFilterName.js.map